<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-form size="small" label-width="100px">
        <!-- 第一行 -->
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="案件批次号">
              <batch-selector v-model="batchId" :batchNo="batchNoDefault" :testing="false"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="导入时间">
              <el-date-picker v-model="searchReq.importStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="searchReq.importEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="公司名称" v-if="this.$partB()">
              <el-select v-model="companyId" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id" :title="item.companyName"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right">
        <el-button @click="searchReq.page = 1;replyList()" type="primary" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
        <el-button @click="reset" size="mini">重置</el-button>
      </div>
    </div>
    <div class="index-section m-t-24">
      <div class="panel">
        <div class="panel-content">
          <el-table
            ref="singleTable"
            :data="replyRes.list"
            v-loading="loading"
            size="small"
            @row-click="toDetail"
            highlight-current-row
            style="width: 100%">
            <el-table-column
              property="aCaseId"
              fixed
              align="center"
              label="进件号">
            </el-table-column>
            <el-table-column
              property="loanInstitutions"
              align="center"
              label="贷款机构">
            </el-table-column>
            <el-table-column
              property="name"
              align="center"
              label="姓名">
            </el-table-column>
            <el-table-column
              property="importTime"
              align="center"
              label="导入日期">
            </el-table-column>
            <el-table-column
              property="responseTime"
              align="center"
              label="回复时间">
            </el-table-column>
            <el-table-column
              property="content"
              align="center"
              label="回复内容">
            </el-table-column>
            <el-table-column
              property="replyTime"
              align="center"
              label="回复轮次">
            </el-table-column>
            <el-table-column
              property="contactStatus"
              align="center"
              label="本人联系状态">
            </el-table-column>
            <el-table-column
              property="urgeStatus"
              align="center"
              label="作业状态">
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :page-sizes="[10, 20, 50]"
              :total="replyRes.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import BatchSelector from '../../../components/bussiness-select/BatchSelector';

const Base64 = require('js-base64').Base64;

export default {
  inject: ['reload'],
  data() {
    return {
      loading: false,
      companyRes: [],
      companyId: [],
      batchId: [],
      searchReq: {
        page: 1,
        limit: 50,
        // 搜索条件
        companyId: null,
        batchId: null,
        importStartTime: null,
        importEndTime: null
      },
      replyRes: { 'totalRecords': 0, list: [] },
      batchNoDefault: [],
      certificate: null
    };
  },
  mounted() {
    this.getTime();
    this.replyList();
    this.companyList();
  },
  methods: {
    getTime() {
      const day = new Date();
      day.setTime(day.getTime() - (24 * 60 * 60 * 1000 * 6));
      const s1 = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()} 00:00:00`;
      this.searchReq.importStartTime = s1;
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
      });
    },
    replyList() {
      this.loading = true;
      if (this.batchId.join(',')) {
        this.searchReq.batchNo = this.batchId.join(',');
      }
      if (this.companyId.join(',')) {
        this.searchReq.companyId = this.companyId.join(',');
      }
      this.$ajax({
        method: 'POST',
        url: '/overview/queryAllResponse',
        data: this.searchReq
      }).then((res) => {
        this.replyRes.list = res.data.list;
        this.replyRes.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.replyList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.replyList();
    },
    reset() {
      const date = moment(Date.now()).format('YYYY-MM-DD');
      this.searchReq.page = 1;
      this.searchReq.limit = 50;
      this.searchReq.companyId = [];
      this.searchReq.batchId = [];
      this.searchReq.dataSource = [0, 1, 2];
      this.searchReq.status = ['paying', 'paid'];
      this.searchReq.repayStartTime = `${date} 00:00:00`;
      this.searchReq.repayEndTime = `${date} 23:59:59`;
      this.reload();
    },
    toDetail(row) {
      window.open(`/main/case/detail/${Base64.encode(row.caseId)}`);
    }
  },
  components: {
    BatchSelector
  }
};
</script>
<style lang="less" scoped>
  .rate-component {
    span {
      display: inline-block;
      width: 20px;
      vertical-align: middle;
    }
    & > div {
      display: inline-block;
      width: 160px;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main/reply/list.vue